module.exports = __webpack_public_path__ + "/img/6b96c74dd6999eed41ca2ffdffce51b7.png";


/*****************
 ** WEBPACK FOOTER
 ** ./src/client/assets/appimg/course-icon.png
 ** module id = 22
 ** module chunks = 0 1 2 3 4 5
 **/